import React, { useState, useEffect } from 'react';
import "./ImportProductCategory.css";
import { FaArrowAltCircleLeft } from "react-icons/fa";
import { Form } from "react-bootstrap";
import { useNavigate } from 'react-router-dom';
import { uploadProductCategoryFile, getProductCategories } from '../../services/http';
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { toast } from 'react-toastify';


const ImportProductCategory = () => {

    const navigate = useNavigate()

    const [selectedFile, setSelectedFile] = useState();
    const [isFilePicked, setIsFilePicked] = useState(false);
    const [showError, setShowError] = useState(false)
    


  const dispatch = useDispatch();


  const states = useSelector((state) => state, shallowEqual);

    const handleFileChoose = (e) => {
        const value = e.currentTarget.files[0]
        console.log(value)
        setSelectedFile(value)
    }

    const handleImportData = async (e) => {
        const req = await uploadProductCategoryFile(selectedFile, states.userToken.access_token)
        if (req.response && req.response.status !== 200) {
            // let errorMsg = reqdata.response?.data.error["libelle"][0];

           
            
            toast.error(req.response?.data.error, {
                position: toast.POSITION.TOP_RIGHT
            });
            
        } else {
            console.log("Here we are")
            toast.success(`Import effectué avec succès !`, {
                position: toast.POSITION.TOP_RIGHT
              });
             let response = await getProductCategories(states.userToken.access_token, 1, "");
 
             let response_copy = response.data.data.map(obj => ({ ...obj, showEdit: false, showDelete: false }))
 
             dispatch({
                 type: "SET",
                 key: "productCategoriesList",
                 payload: response_copy,
             });
                 
        
                }
        
    }
    return (
        <div className="import-product-category-list-container">
            <div className="ml-2 row">
                <button className="btn btn-rounded mb-2 mr-2 btn-md" onClick={() => { navigate("/product-category") }}><FaArrowAltCircleLeft className="mr-1" /> Retour</button>
            </div>
            <div className="ml-2 row my-2">
                <h3 className="mb-2 bold">Importer des catégories de produits</h3>
            </div>
            <div className=" widget-content-area br-6 mb-3">
                <h5 className="mb-2 bold text-left">1. Télécharger et remplir le modèle</h5>
                <p className="text-justify">
                L'importation des catégories d'institutions se fait via un fichier excel. Il vous suffit donc de remplir votre fichier excel en suivant le format recommandé. Vous pouvez télécharger un modèle en cliquant sur le bouton ci-dessous.
                </p>


                <button className="btn btn-dark mb-3 btn-lg" target={"_blank"} href={"le_lien_vers_le_fichier"}>Télécharger le modèle exemple</button>

            </div>

            <div className=" widget-content-area br-6">
                <h5 className="mb-2 bold text-left">2. Importer vos catégories de produits via votre excel</h5>
                <p className="text-left">Vous avez à présent un fichier excel contenant vos catégories au format recommandé. Vous pouvez importer vos catégories en chargeant votre fichier dans le champ ci-dessous.
                </p>

                <br />                                                                                                                                                                                                                                                                                                                          
                <div className=" d-flex justify-content-between flex-wrap">
                    <div className="text-left inputFileDivinputFileDiv">
                        <div className="custom-file mb-4 custom-file-import-display">
                            <input type="file" onChange={(e) => handleFileChoose(e)} className="custom-file-input" id="customFile" />
                            <label className="custom-file-label" for="customFile">{selectedFile ? selectedFile.name : "Aucun fichier"}</label>
                        </div>
                    </div>

                    <div className="text-right">
                        <button className="btn btn-dark mb-3 btn-md" onClick={handleImportData}>Importer les catégories de produits</button>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default ImportProductCategory
